export const ActionTypes = {
  SET_OEE_GRID: 'services/dashboards/oeeGridDashboard/set_oee_grid',
  FETCH_ALL: 'services/lines/fetch_all',
  FETCH_LINE: 'services/lines/fetch_line',
  GET_ALL: 'services/lines/get_all',
  FETCH_ALL_BY_FACTORY_ID: 'services/lines/fetch_all_by_factory_id',
  SET_ALL_BY_FACTORY_ID: 'services/lines/set_all_by_factory_id',
  FETCH_ALL_SUCCESS: 'services/lines/fetch_all_success',
  SET_LOADER_STATUS: 'services/lines/set_loader_status',
  SET_ALL: 'services/lines/set_all',
  SET_LINE: 'services/lines/set_line',
  ADD_OR_UPDATE_LINE: 'services/lines/add_or_update_line',
  DELETE_LINE: 'services/lines/delete_line',
  FETCH_LINE_DETAIL_OEE: 'services/lines/fetch_line_detail_oee',
  SET_LINE_DETAIL_OEE: 'services/lines/set_line_detail_oee',
  FETCH_LINE_TREND: 'services/lines/fetch_line_trend',
  SET_LINE_TREND: 'services/lines/set_line_trend',
  FETCH_LINE_VISION_EQUIPMENTS: 'services/lines/fetch_line_vision_equipments',
  SET_LINE_VISION_EQUIPMENTS: 'services/lines/set_line_vision_equipments',
};

const setOeeGrid = ({ oeeGrid }) => ({
  oeeGrid,
  type: ActionTypes.SET_OEE_GRID,
});
const fetchAll = ({ lineParams }) => ({
  lineParams,
  type: ActionTypes.FETCH_ALL,
});
const fetchLine = ({ lineId }) => ({
  lineId,
  type: ActionTypes.FETCH_LINE,
});
const fetchLineTrend = ({ trendRequestModel }) => ({
  trendRequestModel,
  type: ActionTypes.FETCH_LINE_TREND,
});

const getAll = () => ({
  type: ActionTypes.GET_ALL,
});

const fetchAllFactoryLines = ({ factoryId }) => ({
  factoryId,
  type: ActionTypes.FETCH_ALL_BY_FACTORY_ID,
});

const setAllFactoryLines = ({ factoryLines }) => ({
  factoryLines,
  type: ActionTypes.SET_ALL_BY_FACTORY_ID,
});

const setLoader = ({ showLoader }) => ({
  showLoader,
  type: ActionTypes.SET_LOADER_STATUS,
});

const setAll = ({ allLine }) => ({
  allLine,
  type: ActionTypes.SET_ALL,
});
const setLine = ({ line }) => ({
  line,
  type: ActionTypes.SET_LINE,
});

const addorUpdateLine = ({ lineData, actionName, lineParams, callback }) => ({
  lineData,
  actionName,
  lineParams,
  callback,
  type: ActionTypes.ADD_OR_UPDATE_LINE,
});

const deleteLine = ({ id, lineParams }) => ({
  id,
  lineParams,
  type: ActionTypes.DELETE_LINE,
});

const fetchLineDetailOEE = ({ lineId, factoryId }) => ({
  lineId,
  factoryId,
  type: ActionTypes.FETCH_LINE_DETAIL_OEE,
});

const setLineDetailOEE = ({ lineDetailOEE }) => ({
  lineDetailOEE,
  type: ActionTypes.SET_LINE_DETAIL_OEE,
});

const setLineTrend = ({ lineTrend }) => ({
  lineTrend,
  type: ActionTypes.SET_LINE_TREND,
});

const fetchLineVisionEquipments = ({ lineId }) => ({
  lineId,
  type: ActionTypes.FETCH_LINE_VISION_EQUIPMENTS,
});
const setLineVisionEquipments = ({ visionEquipments }) => ({
  visionEquipments,
  type: ActionTypes.SET_LINE_VISION_EQUIPMENTS,
});

export default {
  setOeeGrid,
  fetchAll,
  fetchLine,
  getAll,
  fetchAllFactoryLines,
  setAllFactoryLines,
  setAll,
  setLine,
  setLoader,
  addorUpdateLine,
  deleteLine,
  fetchLineDetailOEE,
  setLineDetailOEE,
  fetchLineTrend,
  setLineTrend,
  fetchLineVisionEquipments,
  setLineVisionEquipments,
};
